import { useRef } from 'react';
import { MapContainer, ScaleControl } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import MapConfig from './utils/map-config.json'; 
import Panels from './Panels';

const Map = () => {
  const settings = MapConfig.Map;
  const mapRef = useRef(null);

  const getZoom = () => {
    let zoom = settings.zoom;
    const params = new URLSearchParams(window.location.search);
    const urlZoom = parseInt(params.get("zoom"), 10);
    if (!isNaN(urlZoom)) {
      zoom = urlZoom;
    }
    return zoom;
  }

  const getCenter = () => {
    let center = settings.center;
    const params = new URLSearchParams(window.location.search);
    const urlLat = parseFloat(params.get("lat"));
    const urlLng = parseFloat(params.get("lng"));
    if (!isNaN(urlLat) && !isNaN(urlLng)) {
      center = [urlLat, urlLng];
    }
    return center;
  }

  return (
    <>
      <MapContainer
        center={getCenter()}
        zoom={getZoom()}
        minZoom={MapConfig.Map.minZoom}
        maxBounds={MapConfig.Map.maxBounds}
        scrollWheelZoom={true}
        zoomControl={false}
        className="map"
        whenCreated={(mapInstance) => {
          mapRef.current = mapInstance;
        }}
        attributionControl={false}
      >
        <ScaleControl position="bottomright" metric={true} imperial={false}/>
        <Panels/>
      </MapContainer>
    </>
  );
};

export default Map;
